import {
  ONLINE_ONLY_FEATURES,
  ONLINE_ONLY_MESSAGES,
  type OfflineAuthProfile,
  type OfflineCatalogSnapshot,
  type OfflineFeature,
} from './types.js';

export function isOnlineOnlyFeature(feature: OfflineFeature): boolean {
  return (ONLINE_ONLY_FEATURES as readonly string[]).includes(feature);
}

export function onlineOnlyMessage(
  feature: 'inventaire' | 'cloture' | 'profile' | 'first_launch' | 'offline_login_unavailable',
): string {
  return ONLINE_ONLY_MESSAGES[feature];
}

/** True when catalog was synced at least once and has products. */
export function hasSyncedCatalog(
  catalog: OfflineCatalogSnapshot | null | undefined,
): boolean {
  return !!catalog && Array.isArray(catalog.products) && catalog.products.length > 0;
}

/**
 * First-launch offline blocker: no prior sync and currently offline.
 */
export function shouldBlockFirstLaunchOffline(params: {
  isOnline: boolean;
  catalog: OfflineCatalogSnapshot | null | undefined;
}): boolean {
  return !params.isOnline && !hasSyncedCatalog(params.catalog);
}

export function canUseFeatureOffline(feature: OfflineFeature): boolean {
  return !isOnlineOnlyFeature(feature);
}

/** Electron offline login: catalog synced + at least one remember-me profile. */
export function canLoginOffline(params: {
  supportsOfflinePos: boolean;
  isOnline: boolean;
  catalog: OfflineCatalogSnapshot | null | undefined;
  authProfiles: OfflineAuthProfile[];
}): boolean {
  if (!params.supportsOfflinePos) return false;
  if (params.isOnline) return true;
  if (!hasSyncedCatalog(params.catalog)) return false;
  return params.authProfiles.length > 0;
}
